import { useDialogState, useRowSelection, useTinhThanh } from './hooks';
import { ActionBar, DeleteDialog, ProvinceDialog } from './components';
import { ErpDataTableV2 } from '@/components/custom/erp';
import { getDataTableColumns } from './cols-definition';

export default function DanhMucTinhThanh() {
  const { provinces, isLoading, addProvince, updateProvince, deleteProvince } = useTinhThanh();
  const { selectedObj, selectedRowIndex, handleRowClick, clearSelection } = useRowSelection();
  const {
    showAddDialog,
    showEditDialog,
    showDeleteDialog,
    showWatchDialog,
    isCopyMode,

    openAddDialog,
    closeAddDialog,
    openEditDialog,
    closeEditDialog,
    openDeleteDialog,
    closeDeleteDialog,
    openWatchDialog,
    closeWatchDialog,

    handleAddButtonClick,
    handleEditButtonClick,
    handleDeleteButtonClick,
    handleCopyButtonClick
  } = useDialogState(clearSelection);

  const tables = [
    {
      name: '',
      rows: provinces,
      columns: getDataTableColumns()
    }
  ];

  return (
    <div className='flex h-full min-h-screen w-full min-w-0 max-w-full flex-col lg:overflow-hidden'>
      {(showAddDialog || showEditDialog) && (
        <ProvinceDialog
          open={showAddDialog || showEditDialog}
          mode={showEditDialog ? 'edit' : 'add'}
          initialData={
            selectedObj && showEditDialog
              ? {
                  ma_tinh: selectedObj.ma_tinh,
                  ten_tinh: selectedObj.ten_tinh,
                  ten_tinh2: selectedObj.ten_tinh2,
                  trang_thai: parseInt(selectedObj.status)
                }
              : selectedObj && showAddDialog && isCopyMode
                ? {
                    ma_tinh: selectedObj.ma_tinh,
                    ten_tinh: selectedObj.ten_tinh,
                    ten_tinh2: selectedObj.ten_tinh2,
                    trang_thai: parseInt(selectedObj.status)
                  }
                : undefined
          }
          onClose={showEditDialog ? closeEditDialog : closeAddDialog}
          selectedObj={showEditDialog ? selectedObj : null}
          addProvince={addProvince}
          updateProvince={updateProvince}
        />
      )}

      {showDeleteDialog && (
        <DeleteDialog
          open={showDeleteDialog}
          onClose={closeDeleteDialog}
          selectedObj={selectedObj}
          deleteProvince={deleteProvince}
          clearSelection={clearSelection}
        />
      )}

      {showWatchDialog && selectedObj && (
        <ProvinceDialog
          open={showWatchDialog}
          mode='view'
          initialData={{
            ma_tinh: selectedObj.ma_tinh,
            ten_tinh: selectedObj.ten_tinh,
            ten_tinh2: selectedObj.ten_tinh2,
            trang_thai: parseInt(selectedObj.status)
          }}
          onClose={closeWatchDialog}
          selectedObj={selectedObj}
          addProvince={addProvince}
          updateProvince={updateProvince}
          onAddButtonClick={handleAddButtonClick}
          onEditButtonClick={handleEditButtonClick}
          onDeleteButtonClick={handleDeleteButtonClick}
          onCopyButtonClick={handleCopyButtonClick}
        />
      )}

      <div className='w-full'>
        <ActionBar
          onAddIconClick={openAddDialog}
          onEditIconClick={() => selectedObj && openEditDialog()}
          onDeleteIconClick={() => selectedObj && openDeleteDialog()}
          onCopyIconClick={() => selectedObj && handleCopyButtonClick()}
          onWatchIconClick={() => selectedObj && openWatchDialog()}
        />

        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          loading={isLoading}
        />
      </div>
    </div>
  );
}
